import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  submenuInlineButton: {
    color: 'rgba(255, 255, 255, 0.50)',
    height: '3rem',
    padding: theme.spacing(1, 0, 1, 8),
    width: '100%',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.10)'
    }
  },
  submenuInlineText: {
    '& > .MuiTypography-root': {
      fontSize: '1rem',
      whiteSpace: 'nowrap'
    }
  },
  submenuInlineNavLink: {
    position: 'relative',
    textDecoration: 'none',
    width: '100%',
    zIndex: 0,
    '&.active': {
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
      '& .MuiTypography-root': {
        color: theme.vars.palette.common.white
      }
    }
  }
}));

export default useStyles;
